import { useId } from 'react';

export const OneLineInput = ({
  label,
  name,
  type = 'text',
  placeholder,
  description,
  onChange,
  value,
  max,
  min,
  className,
  inputRef,
  labelClasses = ''
}) => {
  const id = useId();
  const descriptionId = useId();
  return (
    <div className={`group relative w-full ${className}`}>
      <label
        htmlFor={id}
        className={`transtion-all absolute -top-7 left-1 text-xl/6 font-medium text-gray-900 duration-300 group-has-[:focus]:-top-10 ${labelClasses}`}
      >
        {label}
      </label>
      <div className="">
        <input
          ref={inputRef}
          id={id}
          name={name}
          type={type}
          placeholder={placeholder}
          aria-describedby={descriptionId}
          value={value ?? undefined}
          max={max ?? null}
          min={min ?? null}
          onChange={(e) => onChange(e.target.value)}
          className="focus:outline-pdteal block w-full rounded-md bg-white px-6 py-6 text-2xl text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 sm:text-2xl/6"
        />
      </div>
      {description && (
        <p id={descriptionId} className="mt-2 text-sm text-gray-500">
          {description}
        </p>
      )}
    </div>
  );
};
